// Imports components
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "./Navigation";
import GlobalFooter from "./GlobalFooter";

type Props = {
  children: React.ReactNode;
};

/**
 * Layout component that wraps the content and sets up the HTML structure.
 * @param {React.ReactNode} children - The content to be rendered inside the layout.
 * @returns The rendered layout component.
 */
export default function Layout({ children }: Props) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="pt-16 lg:pt-0 lg:pl-16 flex-1 transition-all duration-300">
        {children}
      </main>
      <div className="lg:pl-16">
        <GlobalFooter />
      </div>
    </div>
  );
}
